<template>
  <div class="flex flex-row items-center justify-between">
    <div class="text-txprimary/60 text-sm">{{ label }}</div>
    <div class="flex flex-row items-center gap-2">
      <svg width="80" height="8" viewBox="0 0 80 8" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="80" height="8" rx="4" fill="#3176FF14" />
        <rect :width="barWidth" height="8" rx="4" :fill="color" />
      </svg>
      <div class="text-primary text-sm min-w-[2rem] text-right">{{ percent }}%</div>
    </div>
  </div>
</template>

<script lang="ts" setup>
  interface Props {
    label: string;
    percent: number;
    color?: string;
    maxWidth?: number;
  }

  const props = withDefaults(defineProps<Props>(), {
    color: "#3176FF",
    maxWidth: 80,
  });

  const barWidth = computed(() => {
    return Math.max(0, Math.min(props.maxWidth, (props.percent / 100) * props.maxWidth));
  });
</script>
